import 'antd/dist/reset.css';
import '../../resets.css';
import '../../globals.css';
import '../../fonts.css';

import type { ReactNode } from 'react';
import { StyleProvider as AntStyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import { useFela } from 'react-fela';

import type { Theme } from '@/styles/theme';

interface StyleProviderProps {
    children: ReactNode;
}

export const StyleProvider = ({ children }: StyleProviderProps) => {
    const { theme } = useFela<Theme>();

    return (
        <AntStyleProvider transformers={[legacyLogicalPropertiesTransformer]}>
            <ConfigProvider
                theme={{
                    token: {
                        fontFamily: theme.fontFamily,

                        colorLinkActive: theme.colors.blue,
                        colorLinkHover: theme.colors.blue,

                        linkDecoration: 'none',
                        linkFocusDecoration: 'underline',
                        linkHoverDecoration: 'underline',

                        borderRadius: 4,
                    },
                }}
            >
                {children}
            </ConfigProvider>
        </AntStyleProvider>
    );
};
